import { useOnline } from "./app-context";
import { useT } from "./use-t";

/**
 * Actions that change money, cover or data are unavailable offline (CAP-4).
 * Buttons use `aria-disabled` plus the visible reason, never native disabled.
 */
export function useMutationGate(): { blocked: boolean; reason?: string } {
  const online = useOnline();
  const t = useT();
  return online ? { blocked: false } : { blocked: true, reason: t("offline.actionUnavailable") };
}
